import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import { MatIconModule} from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import { WizLayoutModule } from '../../layouts/wiz-layout.module';
import { WizStylingDirectiveModule } from '../../../directives/styling/wiz-styling-directives.module';
import { WizLabelModule } from '../wiz-label/wiz-label.module';
import { WizBehaviorDirectiveModule } from '../../../directives/behavior/wiz-behavior-directives.module';
import { WizTextarea } from './wiz-text-area/wiz-text-area';
import { WizNumericInput } from './wiz-numeric-input/wiz-numeric-input';
import { WizTranslationInput } from './wiz-translation/wiz-translation-input';
import { WizTranslationInputPop } from './wiz-translation/wiz-translation-input.pop';
import { WizImageModule } from '../wiz-image/wiz-image.module';
import { WizTextInput } from './wiz-text-input/wiz-text-input';
import { WizValidatorModule } from '../../../directives/validators/wiz-validator.module';
import { WizTranslationBasicPop } from './wiz-translation/basic/wiz-translation.basic.pop';
import { WizTranslationBasic } from './wiz-translation/basic/wiz-translation.basic';
import { WizIconModule } from '../wiz-icon/wiz-icon.module';


@NgModule({
  declarations: [WizTextInput, WizTextarea, WizNumericInput, WizTranslationInput, WizTranslationInputPop, WizTranslationBasic, WizTranslationBasicPop],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    ReactiveFormsModule,
    MatButtonModule,
    WizLayoutModule,
    WizStylingDirectiveModule,
    WizLabelModule,
    WizImageModule,
    WizIconModule,
    WizBehaviorDirectiveModule, WizValidatorModule
  ],
  exports: [WizTextInput, WizTextarea, WizNumericInput, WizTranslationInput, WizTranslationInputPop, WizTranslationBasic, WizTranslationBasicPop]
})
export class WizInputModule { }
